import {Component, OnInit, ViewChild} from '@angular/core';
import {SelectItem} from 'primeng/primeng';
import {LazyLoadEvent} from 'primeng/primeng';
import {PositionService} from '../services/position.service';
import {DeviceService} from '../services/device.service';
import {UserService} from '../services/user.service';
import {Message} from 'primeng/primeng';
import {AddressService} from '../services/address.service';
import {Table} from 'primeng/components/table/table';
import * as XLSX from 'xlsx';
import {environment} from '../../environments/environment';

@Component({
    selector: 'app-driving-outside-hours-report',
    templateUrl: './driving-outside-hours-report.component.html',
    styleUrls: ['./driving-outside-hours-report.component.css']
})
export class DrivingOutsideHoursReportComponent implements OnInit {
    fileName: String;
    options: any;
    overlays: any[];
    position: any;
    positions: any [];
    devices: SelectItem[];
    dateOptions: SelectItem[];
    dateOption: any;
    idDevice: String;
    disabledInitialDate: boolean;
    disabledFinalDate: boolean;
    initialDate: Date;
    finalDate: Date;
    msgs: Message[] = [];
    blockedDocument: boolean = false;
    cols: any[];
    displayLocation: boolean = false;
    maxDays: number = 35;

    @ViewChild('dt') table: Table;

    constructor(private positionService: PositionService, private deviceService: DeviceService,
                private userService: UserService, private addressService: AddressService) {
    }

    ngOnInit() {
        this.cols = [
            {field: 'nameDevice', header: 'NOMBRE'},
            {field: 'from', header: 'DESDE'},
            {field: 'fromAddress', header: 'DESDE DIRECCION'},
            {field: 'to', header: 'HASTA'},
            {field: 'toAddress', header: 'HASTA DIRECCION'},
            {field: 'distanceTraveled', header: 'DISTANCIA (km)'},
            {field: 'duration', header: 'DURACION'},
            {field: 'speedMax', header: 'VELOCIDAD MAXIMA (km/hr)'}
        ];
        this.dateOptions = [
            {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
            {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
            {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
            {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
        ];

        this.devices = [];
        this.deviceService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
            let response: any = data;
            response.devices.forEach(item => {
                this.devices.push({label: item.name, value: item.idDevice});
            });
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
        });
        this.dateOption = '7';
        this.changeDate();
    }

    changeDate() {
        this.disabledInitialDate = true;
        this.disabledFinalDate = true;
        const dateTime = new Date();
        if (this.dateOption === 'T') {
            this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 0, 0, 0));
            this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
        } else if (this.dateOption === 'Y') {
            this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate() - 1, 0, 0, 0));
            this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate() - 1, 23, 59, 59));
        } else if (this.dateOption === '7') {
            this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate() - 6, 0, 0, 0));
            this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
        } else {
            this.disabledInitialDate = false;
            this.disabledFinalDate = false;
        }
    }

    diferenciaEntreFechasEnDias(a: Date, b: Date): number {
        return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
    }

    buscar() {
        if (this.table) {
            this.table.first = 1;
        }
        this.fileName = 'ConduccionFueraHorario_';
        this.devices.forEach(item => {
            if (item.value == this.idDevice) {
                this.fileName = this.fileName + item.label;
            }
        });
        if (this.diferenciaEntreFechasEnDias(this.initialDate, this.finalDate) > this.maxDays) {
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'El rango de fechas no debe exceder los ' + this.maxDays + ' dias'
            }];
            return;
        }
        if (this.initialDate >= this.finalDate) {
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'La fecha final debe ser superior a la fecha inicial'
            }];
            return;
        }
        this.blockedDocument = true;
        this.positions = [];
        this.positionService.findDrivingOutsideHours(this.idDevice, this.initialDate, this.finalDate).then(data => {
            let response: any = data;
            response.positions.forEach(item => {
                item.latitude = item.latitude.toFixed(6);
                item.longitude = item.longitude.toFixed(6);
                item.latitudeTo = item.latitudeTo.toFixed(6);
                item.longitudeTo = item.longitudeTo.toFixed(6);
                item.speedMax = item.speedMax.toFixed(2);
                item.speedAvg = (item.speedSum / item.totalRecords).toFixed(2);
                item.distanceTraveled = (item.distanceTraveled / 1000).toFixed(2);
                item.latLng = item.latitude + ', ' + item.longitude
                item.latLngTo = item.latitudeTo + ', ' + item.longitudeTo
                this.positions.push(item);
            });
            this.blockedDocument = false;
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
            this.blockedDocument = false;
        });

    }

    showInMap(position: any) {
        this.position = position;
        let latLng = new google.maps.LatLng(position.latitude, position.longitude);
        this.options = {
            zoom: 13,
            center: latLng
        };
        let labelStart = {text: 'DESDE', color: 'deepskyblue', fontSize: '12px', fontWeight: 'bold'};
        let iconStart = {
            url: 'assets/layout/images/markers/blue.png', // url
            scaledSize: new google.maps.Size(45, 45), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(22.5, 38), // anchor,
            labelOrigin: new google.maps.Point(22, -5)
        };
        let labelFinal = {text: 'HASTA', color: 'green', fontSize: '12px', fontWeight: 'bold'};
        let iconFinal = {
            url: 'assets/layout/images/markers/green.png', // url
            scaledSize: new google.maps.Size(45, 45), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(22.5, 38), // anchor,
            labelOrigin: new google.maps.Point(22, -5)
        };

        this.overlays = [];
        this.displayLocation = true;
        this.blockedDocument = true;
        let recorrido = new google.maps.Polyline({
            geodesic: true,
            strokeColor: '#FF0000',
            strokeOpacity: 1.0,
            strokeWeight: 3
        });
        this.overlays.push(recorrido);

        let latLngFinal = null;
        this.positionService.findRange(position.idDevice, position.idPosition, position.idPositionFinal).then(data => {
            let response: any = data;
            response.positions.forEach(item => {
                let latLng = new google.maps.LatLng(item.latitude, item.longitude);
                recorrido.getPath().push(latLng);
                latLngFinal = new google.maps.LatLng(item.latitude, item.longitude);
            });
            let markerStart = new google.maps.Marker({position: latLng, icon: iconStart, label: labelStart});

            this.overlays.push(markerStart);

            let markerFinal = new google.maps.Marker({position: latLngFinal, icon: iconFinal, label: labelFinal});
            this.overlays.push(markerFinal);

            this.blockedDocument = false;
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
            this.blockedDocument = false;
        });
    }

    getAddressTo(position: any) {
        //let latLng = new google.maps.LatLng(position.latitudeTo, position.longitudeTo);
        let request = {
            latitude: position.latitudeTo,
            longitude: position.longitudeTo,
            idDevice: position.idDevice,
            deviceTime: position.deviceTime
        }
        this.blockedDocument = true;
        this.addressService.findAddressByCoordinates(request).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                position.toAddress = response.address;
                this.msgs = [{severity: 'info', summary: 'INFO', detail: 'Dirección obtenida Exitosamente'}];
            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }
            this.blockedDocument = false;
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
            this.blockedDocument = false;
        });
        ;
    }

    getAddressFrom(position: any) {
        let request = {
            latitude: position.latitude,
            longitude: position.longitude,
            idDevice: position.idDevice,
            deviceTime: position.deviceTime
        }
        this.blockedDocument = true;
        this.addressService.findAddressByCoordinates(request).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                position.fromAddress = response.address;
                this.msgs = [{severity: 'info', summary: 'INFO', detail: 'Dirección obtenida Exitosamente'}];
            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }
            this.blockedDocument = false;
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
            this.blockedDocument = false;
        });
        ;
    }

    hide() {
        this.displayLocation = false;
    }

    exportXLS() {
        let records = [];
        this.positions.forEach(item => {
            let data = {};
            this.cols.forEach(col => {
                data[col.header] = item[col.field];
            });
            records.push(data);
        });

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
        const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
        XLSX.writeFile(workbook, this.fileName + '.xlsx');
    }

    exportPDF() {
        window.open(environment.reportsEndPoint + 'viewDrivingOutsideHoursReport?' +
            'idDevice=' + this.idDevice +
            '&startDate=' + this.initialDate.toISOString() +
            '&endDate=' + this.finalDate.toISOString()
            , '_blank');
    }
}



// WEBPACK FOOTER //
// ./src/app/driving-outside-hours-report/driving-outside-hours-report.component.ts